var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.10074C5.10218 2.10074 4.72064 2.24829 4.43934 2.51093C4.15804 2.77357 4 3.12979 4 3.50123C4 3.87266 4.15804 4.22888 4.43934 4.49152C4.72064 4.75417 5.10218 4.90172 5.5 4.90172C5.89782 4.90172 6.27936 4.75417 6.56066 4.49152C6.84196 4.22888 7 3.87266 7 3.50123C7 3.12979 6.84196 2.77357 6.56066 2.51093C6.27936 2.24829 5.89782 2.10074 5.5 2.10074ZM5.5 5.83538C4.83696 5.83538 4.20107 5.58946 3.73223 5.15172C3.26339 4.71398 3 4.12028 3 3.50123C3 2.88217 3.26339 2.28847 3.73223 1.85073C4.20107 1.41299 4.83696 1.16708 5.5 1.16708C6.16304 1.16708 6.79893 1.41299 7.26777 1.85073C7.73661 2.28847 8 2.88217 8 3.50123C8 4.12028 7.73661 4.71398 7.26777 5.15172C6.79893 5.58946 6.16304 5.83538 5.5 5.83538ZM5.5 0C3.07 0 0.89 1.40049 0 3.50123C1.195 6.33955 4.625 7.73071 7.665 6.61498C9.19 6.05479 10.4 4.92973 11 3.50123C10.11 1.40049 7.93 0 5.5 0Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.7850730162e88f4d88354e1f380c8e9d.svg";
export { ForwardRef as ReactComponent };